import { useEffect } from 'react';
import type { MapOf } from 'corgi-types';

export interface LazyStyles {
  use: () => void;
  unuse: () => void;
}

const stylesMap: MapOf<string, number> = {};

export const useStylesWithoutDuplicates = (
  identifier: string,
  // `styles` are processed differently in Next.js `prod` and `dev` builds.
  // It is imported as an `empty object` in PROD and as a `string` in DEV.
  styles: LazyStyles
) => {
  stylesMap[identifier] = stylesMap[identifier] || 0;

  useEffect(() => {
    if (stylesMap[identifier] === 0 && typeof styles === 'object' && 'use' in styles) {
      styles.use();
    }

    stylesMap[identifier] = stylesMap[identifier] + 1;

    return () => {
      stylesMap[identifier] = stylesMap[identifier] - 1;

      if (stylesMap[identifier] === 0 && typeof styles === 'object' && 'unuse' in styles) {
        styles.unuse();
      }
    };
  }, []);
};
